import bus from "../components/bus"
import Router from "vue-router"
import Axios from "../axios.config"
import qs from "qs"

export default {
  state: {
    arrNum: "",
    isClose: false,
    form: {
      name: '',
      desc: ''
    },
    nodeId: 0,
    sid: [],
    number: [],
    names: [],
    cid: [],
    groupParentId: "",
    selectData: [],
    treeNode: null,
    namereturn: '',
    loading: false,
    type1: "",
    lineState: "",
    clientName: "",
    materialList: [],
    currentPage: 1, //分页的当前页
    total: 0, //总页数\
    sterId: 1,

  },
  getter() {
  },
  mutations() {
  },
  actions: {
    //获取设备分组
    async teSetTree({dispatch, state}) {

      state.loading = true
      var zTree
      var t = $("#container")
      let rMenu = $(".rMenu")

      let funcs = {
        RightClick: function (event, tree, treeNode) {
          $(".curSelectedNode").removeClass("curSelectedNode")
          $(event.target).parent().addClass("curSelectedNode")
          state.namereturn = treeNode.name
          state.treeNode = treeNode
          if (!treeNode) {
            return
          }
          funcs.showRMenu(treeNode.type, treeNode.id, event.clientX, event.clientY, event.screenY)
        },
        showRMenu: function (type, id, x, y, y1) {
          rMenu.hide()
          let H = $(document).height()
          if (id == 1) {
            return
          }
          if (id == -1) {
            state.treeNode = null
            return
          }
          if (type == "folder" && id < 1) {
            if (H - 100 - y1 <= $("#rMenu_top").height()) {
              y = y - $("#rMenu_top").height()
            }

            $("#rMenu_top").show()
          } else if (type == "client") {
            if (H - 100 - y1 <= $("#rMenu_tow").height()) {
              y = y - $("#rMenu_tow").height()
            }
            $("#rMenu_tow").show()
          } else {
            if (H - 100 - y1 <= $("#rMenu_one").height()) {
              y = y - $("#rMenu_one").height()
            }

            $("#rMenu_one").show()
          }
          rMenu.css({"top": y + "px", "left": x + "px", "visibility": "visible"}) //设置右键菜单的位置、可见
          $("body").bind("mousedown", funcs.BodyMouseDown)
        },
        BodyMouseDown: function (event) {
          if (!(event.target.id == "rMenu" || $(event.target).parents(".rMenu").length > 0)) {
            rMenu.css({"visibility": "hidden"})
          }
        },
        fuzzySearch: function (zTreeId, searchField, isHighLight, isExpand) {
          var zTreeObj = $.fn.zTree.getZTreeObj(zTreeId) //获取树对象
          if (!zTreeObj) {
            // alter("获取树对象失败")
            alert("获取树对象失败")
          }
          var nameKey = zTreeObj.setting.data.key.name //获取name属性的key
          isHighLight = isHighLight === false ? false : true//除直接输入false的情况外,都默认为高亮
          isExpand = isExpand ? true : false
          zTreeObj.setting.view.nameIsHTML = isHighLight //允许在节点名称中使用html,用于处理高亮

          var metaChar = '[\\[\\]\\\\\^\\$\\.\\|\\?\\*\\+\\(\\)]' //js正则表达式元字符集
          var rexMeta = new RegExp(metaChar, 'gi') //匹配元字符的正则表达式

          // 过滤ztree显示数据
          function ztreeFilter(zTreeObj, _keywords, callBackFunc) {
            if (!_keywords) {
              _keywords = '' //如果为空，赋值空字符串
            }

            // 查找符合条件的叶子节点
            function filterFunc(node) {
              if (node && node.oldname && node.oldname.length > 0) {
                node[nameKey] = node.oldname //如果存在原始名称则恢复原始名称
              }
              node.highlight = false //取消高亮
              zTreeObj.updateNode(node) //更新节点让之前对节点所做的修改生效
              if (_keywords.length == 0) {
                //如果关键字为空,返回true,表示每个节点都显示
                zTreeObj.showNode(node)
                zTreeObj.expandNode(node, isExpand) //关键字为空时是否展开节点
                return true
              }
              //节点名称和关键字都用toLowerCase()做小写处理
              if (node[nameKey] && node[nameKey].toLowerCase().indexOf(_keywords.toLowerCase()) != -1) {
                if (isHighLight) { //如果高亮，对文字进行高亮处理
                  //创建一个新变量newKeywords,不影响_keywords在下一个节点使用
                  //对_keywords中的元字符进行处理,否则无法在replace中使用RegExp
                  var newKeywords = _keywords.replace(rexMeta, function (matchStr) {
                    //对元字符做转义处理
                    return '\\' + matchStr

                  })
                  node.oldname = node[nameKey] //缓存原有名称用于恢复
                  //为处理过元字符的_keywords创建正则表达式,全局且不分大小写
                  var rexGlobal = new RegExp(newKeywords, 'gi') //'g'代表全局匹配,'i'代表不区分大小写
                  //无法直接使用replace(/substr/g,replacement)方法,所以使用RegExp
                  node[nameKey] = node.oldname.replace(rexGlobal, function (originalText) {
                    //将所有匹配的子串加上高亮效果
                    var highLightText =
                      '<span style="color: whitesmoke;background-color: darkred;">'
                      + originalText
                      + '</span>'
                    return originalText
                  })
                  zTreeObj.updateNode(node) //update让更名和高亮生效
                }
                zTreeObj.showNode(node) //显示符合条件的节点
                return true //带有关键字的节点不隐藏
              }
              zTreeObj.hideNode(node) // 隐藏不符合要求的节点
              return false //不符合返回false
            }

            var nodesShow = zTreeObj.getNodesByFilter(filterFunc) //获取匹配关键字的节点
            processShowNodes(nodesShow, _keywords)//对获取的节点进行二次处理
          }

          /**
           * 对符合条件的节点做二次处理
           */
          function processShowNodes(nodesShow, _keywords) {
            if (nodesShow && nodesShow.length > 0) {
              //关键字不为空时对关键字节点的祖先节点进行二次处理
              if (_keywords.length > 0) {
                $.each(nodesShow, function (n, obj) {
                  var pathOfOne = obj.getPath() //向上追溯,获取节点的所有祖先节点(包括自己)
                  if (pathOfOne && pathOfOne.length > 0) {
                    // i < pathOfOne.length-1, 对节点本身不再操作
                    for (var i = 0; i < pathOfOne.length - 1; i++) {
                      zTreeObj.showNode(pathOfOne[i]) //显示节点
                      zTreeObj.expandNode(pathOfOne[i], true) //展开节点
                    }
                  }
                })
              } else { //关键字为空则显示所有节点, 此时展开根节点
                var rootNodes = zTreeObj.getNodesByParam('level', '0')//获得所有根节点
                $.each(rootNodes, function (n, obj) {
                  zTreeObj.expandNode(obj, true) //展开所有根节点
                })
              }
            }
          }

          //监听关键字input输入框文字变化事件
          $(searchField).bind('input propertychange', function () {
            var _keywords = trim($(this).val())
            searchNodeLazy(_keywords) //调用延时处理
          })

          var timeoutId = null

          // 有输入后定时执行一次，如果上次的输入还没有被执行，那么就取消上一次的执行
          function searchNodeLazy(_keywords) {
            if (timeoutId) { //如果不为空,结束任务
              clearTimeout(timeoutId)
            }
            timeoutId = setTimeout(function () {
              ztreeFilter(zTreeObj, _keywords)   //延时执行筛选方法
              $(searchField).focus()//输入框重新获取焦点
            }, 100)
          }
        }
      }

      var setting = {
        async: {
          enable: true,
          url: "/etv/selectSeachClientTree.json",
          headers: {
            token: localStorage.getItem("token1")
          },
          autoParam: ["id=groupParentId"],
          otherParam: {
            "groupParentId": function () {
              return state.groupParentId
            },
            "type": function () {

              return state.type1
            },
            "onlineState": function () {

              return state.lineState
            },
            "clientName": function () {

              return state.clientName
            }
          },
          dataFilter: filter,
        },
        view: {
          dblClickExpand: false,
          showLine: true,
          selectedMulti: false
        },
        check: {
          enable: true,
          chkboxType: {"Y": "s", "N": "s"}
        },
        data: {
          keep: {
            leaf: true,
            parent: true
          },
          simpleData: {
            enable: true,
            idKey: "id",
            pIdKey: "pId",
            rootPId: ""
          }
        },
        callback: {
          //点击回调
          beforeClick: function (treeId, treeNode) {
            $(".curSelectedNode").removeClass("curSelectedNode")
            if (treeNode.type === "folder") {
              state.currentPage = 1
              state.sterId = treeNode.id
              dispatch('getDate', {
                id: treeNode.id,
                num: 1,
                size: 12
              })
              return
            }
            bus.$emit("addGroupingDatas", treeNode)
          },
          //多选框回调
          onCheck: function () {
            var zTree = $.fn.zTree.getZTreeObj("container"),
              checkCount = zTree.getCheckedNodes(true)
            let checkCount_new = checkCount.filter(function (item) {
              if (item.type === "folder") {
                return false
              } else {
                return true
              }

            })

            state.selectData = checkCount_new

            dispatch("batchAdd", checkCount_new)
          },
          //右键回调
          onRightClick: funcs.RightClick,

          //重名回调

          function(treeId, treeNode, newName) {

            if (treeNode.type === "folder") {
              var pares = {
                id: treeNode.id,
                name: newName,
                type: "group"
              }
            } else if (treeNode.type !== "folder") {
              var pares = {
                id: treeNode.cid,
                name: newName,
                type: "client"
              }
            }
          },

          beforeRename: function (treeId, treeNode, newName) {

            if (treeNode.type === "folder") {

              var pares = {
                id: treeNode.id,
                name: newName,
                type: "group"
              }
            } else if (treeNode.type !== "folder") {
              var pares = {
                id: treeNode.cid,
                name: newName,
                type: "client"
              }
            }

          },

          onAsyncError: function (e) {
          }
        }
      }

      function filter(treeId, parentNode, childNodes) {
        if (childNodes.code == 401) {
          localStorage.removeItem("token1")
          Router.push("/login")
          return
        }

        let data = childNodes.data.children[0]
        if (data.name.includes("设备管理")) {
          data.id = -1
          data.type = 'folder'
        }
        state.loading = false


        data.open = true
        data.icon = "/web/static/images/icon/folder.png"

        return data

      }

      await function () {
        zTree = $.fn.zTree.init(t, setting)
        funcs.fuzzySearch("container", "#searcha", null, true)
      }()
    },

    search({dispatch, state}, data) {
      state.groupParentId = ""
      state.lineState = data.state
      state.clientName = data.Keyword
      dispatch("teSetTree")
    },

    alterClose({dispatch, state}, data) {
      state.isClose = data
    },

    alterForm({dispatch, state}) {
      state.form.desc = ""
      state.form.name = ""
    },

    //批量增加
    batchAdd({dispatch, state}, data) {
      state.sid = []
      state.number = []
      state.names = []
      state.cid = []
      for (let i = 0, h = data.length; i < h; i++) {
        let obj = {}
        obj.id = data[i].clId == undefined ? data[i].id : data[i].clId
        obj.clientNo = data[i].number == undefined ? data[i].clNo : data[i].number
        state.sid.push(obj)
        state.number.push(data[i].number == undefined ? data[i].clNo : data[i].number)
        state.names.push(data[i].name)
        state.cid.push(data[i].clId == undefined ? data[i].id : data[i].clId)
      }
    },

    getDate({state}, obj) {
      Axios.post("/etv/selectPageClientInfo.json", qs.stringify({
        gpId: obj.id,
        pageNum: obj.num,
        pageSize: obj.size,
      })).then(res => {
        if (res.data.code === 0) {
          state.materialList = res.data.data.materialList
          state.total = res.data.data.totalNum

        }
      })

    },
  }
}



// WEBPACK FOOTER //
// ./src/store/terminal.js